export interface INavFavoritesDocument {
  id: string // userId — one document per employer user
  favorites: string[] // ordered favoriteIds, capped at NAV_FAVORITES_MAX
}

/**
 * Shown to users who have never customized favorites (no document exists yet). Frontend-only fallback —
 * nothing is written to Firestore until the user's first toggle persists a real list, which snapshots the
 * then-current defaults into their document (users who have toggled never receive later default changes).
 * Ids must match `favoriteId` declarations in navigation.service.ts — enforced by navigation.service.spec.ts,
 * which is why this lives in the import-free model file rather than either service. Some ids are
 * permission/flag-gated for certain users — accepted: the Favorites renderer respects each row's `isVisible`,
 * so gated entries simply don't render for users who can't see them.
 */
export const DEFAULT_NAV_FAVORITES: string[] = ['openings-manage', 'engage-pipelines', 'engage-applicant-search', 'engage-talent-pool']
